/**A Hook that returns an object containing MUI SX functions or objects. Functions take theme as a parameter and return an object.
 *
 * @returns {object}
 */
const useStyles = () => {
    const groupBoxSx = (theme) => {
        return {
            borderLeft: `1px solid ${theme.palette.grey.main}`,
            mb: theme.spacing(2),
        };
    };

    const groupTitleSx = (theme) => {
        return {
            ml: theme.spacing(5),
            mb: theme.spacing(2),
            fontSize: '1.25rem',
            fontWeight: 500,
        };
    };

    const selectSx = (theme) => {
        return {
            ml: theme.spacing(5),
            mb: theme.spacing(3),
            '& .MuiOutlinedInput-root': {
                width: '26.375rem',
                fontSize: '0.813rem',
            },
        };
    };

    const feeGroupSx = (theme) => {
        return {
            display: 'flex',
            flexDirection: 'row',
            gap: theme.spacing(2),
            pl: theme.spacing(5),
        };
    };

    const feeDescriptionSx = (theme) => {
        return {
            mb: theme.spacing(1),
            width: '26.375rem',
            '& .MuiOutlinedInput-root': {
                fontSize: '0.813rem',
                '& .Mui-disabled': {
                    fontSize: '0.813rem',
                }
            }
        };
    };

    const feeAmountSx = (theme) => {
        return {
            mb: theme.spacing(1),
            width: '7.125rem',
            '& .MuiOutlinedInput-root': {
                fontSize: '0.813rem',
            }
        };
    };

    const feeDeleteButtonSx = (theme) => {
        return {
            mb: theme.spacing(1.25),
        };
    };

    const feeGroupButtonsSx = (theme) => {
        return {
            ml: theme.spacing(5),
            mb: theme.spacing(3),
            display: 'flex',
            width: '34.5rem',
            justifyContent: 'space-between',
        };
    };

    const addGroupButtonSx = (theme) => {
        return {
            width: '50%',
            m: theme.spacing(3),
            borderStyle: 'dashed',
            '&:hover': {
                borderStyle: 'dashed',
            }
        };
    };

    return {
        groupBoxSx,
        groupTitleSx,
        selectSx,
        feeGroupSx,
        feeDescriptionSx,
        feeAmountSx,
        feeDeleteButtonSx,
        feeGroupButtonsSx,
        addGroupButtonSx,
    };
};

export default useStyles;

